import React from 'react';
import PropTypes from 'prop-types';
import config from 'cfg';
import styled from 'styled-components';
import _ from 'lodash';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { loadCommonDictionary, saveWidgetTranslations } from '../common-i18-dashboard-page/actions';
import auth from '../auth';
import RCore from '../../../widgets/components/RCore';
import CommonI18Table from '../common-i18-dashboard-page/components/CommonI18Table';
import SaveTranslationsBtn from '../common-i18-dashboard-page/components/SaveBtn';
import SelectSecondaryLang from '../common-i18-dashboard-page/components/SelectSecondaryLang';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import Toggle from 'material-ui/Toggle';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
// import Chip from 'material-ui/Chip';
import MenuItem from 'material-ui/MenuItem';

// const WidgetDashboardWrapper = styled.div``;

const ControlWrapper = styled.div`
    padding: 15px 0 0;
`;

const Loader = styled.div`
    text-align: center;
    display: flex;
    height: calc(100% - 284px);

    > * {
        margin: auto;
    }
`;

const WidgetI18Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
`;

class WidgetDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            widget: {},
            widgets: [],
            widgetsFiltering: '',
            newWidgetTag: '',
            showSavedNotification: false,
            showErrorNotification: false,
            errorNotificationMessage: '',
            social: true,
            error: false,
        };
    }

    componentDidMount = () => {
        this.loadData()
            .then((widgets = []) => {
                const { widgetId = '' } = this.props.params;
                this.loadI18(widgetId);

                this.setState({
                    widgets,
                    dataLoaded: true,
                });
            })
            .catch(error => {
                console.error(error);
                this.setState({ dataLoaded: true, error: true });
            });
    };

    componentWillReceiveProps(nextProps = {}) {
        if (nextProps.params.widgetId !== this.props.params.widgetId) {
            const { widgetId = '' } = nextProps.params;
            this.loadI18(widgetId);
        }
    }

    loadData = () => {
        return fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}&i18=true`)
            .then(res => res.json())
            .then(data => data.widgets)
            .catch(err => console.error(err));
    };

    loadI18 = widgetId => {
        const user = auth.getUser();
        widgetId = widgetId || this.props.params.widgetId;

        return fetch(
            `/api/i18/${user.client}/${user.username}?access_token=${auth.getAccessToken()}&${
                widgetId ? `widgetId=${widgetId}` : ``
            }`,
        )
            .then(res => res.json())
            .then(({ values = {} }) => values[widgetId] || {})
            .then(i18 => {
                let widget = this.state.widgets.find(({ id }) => id === widgetId) || {};
                widget = { ...widget, i18: { ...widget.i18, ...i18 } };

                this.props.loadCommonDictionary(widget.i18 || {});

                this.setState({ widget });

                return widget;
            })
            .catch(error => console.error(error));
    };

    handleSave = widgetId => {
        const savingWidget = this.state.widget;

        this.setState(
            {
                saving: true,
            },
            () => {
                return fetch
                    .post(
                        `${config.dash.api.host}/api/admin/widgets/${widgetId}?access_token=${auth.getAccessToken()}`,
                        { method: 'PUT' },
                        {
                            widget: savingWidget,
                        },
                    )
                    .then(() => {
                        return fetch.get(
                            `${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`,
                        );
                    })
                    .then(data =>
                        this.setState({
                            ...data,
                            saving: false,
                            showSavedNotification: true,
                            changed: false,
                        }),
                    )
                    .catch(err => console.error(err));
            },
        );
    };

    // handleLocalizationFieldChange = (widgetId, field, newValue) => {
    //     this.setState({
    //         widgets: this.updateWidget(widgetId, field, newValue),
    //         changed: true,
    //     });
    // };

    // updateWidget = (widgetId, field, value) => {
    //     const { widgets } = this.state;
    //     const widget = this.state.widget;
    //     const _widget = _.cloneDeep(widget);
    //     _.set(_widget, field, value);
    //
    //     const widgetIndex = _.findIndex(widgets, w => w.id === widget.id);
    //
    //     return [...widgets.slice(0, widgetIndex), _widget, ...widgets.slice(widgetIndex + 1)];
    // };

    // handleTagAdd = widgetId => {
    //     const { newWidgetTag } = this.state;
    //     const currentWidgetTags = this.state.widget.tags;
    //
    //     this.setState({
    //         widgets: this.updateWidget(widgetId, 'tags', [...currentWidgetTags, newWidgetTag]),
    //         newWidgetTag: '',
    //         changed: true,
    //     });
    // };

    // handleTagDelete = (widgetId, tag) => {
    //     const currentWidgetTags = this.state.widget.tags;
    //
    //     this.setState({
    //         widgets: this.updateWidget(widgetId, 'tags', currentWidgetTags.filter(t => t !== tag)),
    //         changed: true,
    //     });
    // };

    renderWidgetI18 = widget => {
        const inherited = _.get(widget, 'i18.inherited', false);
        const dictionary = _.get(widget, 'i18.en', {});
        const empty = !inherited && _.isEmpty(dictionary);
        // showSavedNotification: true,
        return (
            <div key={widget.id}>
                <WidgetI18Header>
                    <h2>Widget localization</h2>
                    {!inherited && !_.isEmpty(dictionary) && <SelectSecondaryLang />}
                </WidgetI18Header>

                {_.get(widget, 'i18.inherited', false) && <div>I18 is inherited from parent widget</div>}
                {empty ? (
                    <div>Nothing to translate</div>
                ) : (
                    <CommonI18Table statsList={Object.keys(dictionary)} isFinished />
                )}
            </div>
        );
    };

    saveWidgetTranslations = i18 => {
        return this.props.saveWidgetTranslations(this.props.params && this.props.params.widgetId, i18).then(() => {
            this.setState({
                showSavedNotification: true,
            });
        });
    };

    renderWidgetI18Controls = () => {
        return (
            <ControlWrapper>
                <SaveTranslationsBtn primary saveCb={this.saveWidgetTranslations} />
            </ControlWrapper>
        );
    };

    // renderForm = widget => {
    //     return (
    //         <div>
    //             <h3>Widget name localizations</h3>
    //             {supportedLanguages.map(locale => {
    //                 return (
    //                     <TextField
    //                         key={locale}
    //                         fullWidth
    //                         onChange={(e, newValue) =>
    //                             this.handleLocalizationFieldChange(widget.id, `localization.${locale}.name`, newValue)
    //                         }
    //                         value={_.get(widget, `localization.${locale}.name`) || ''}
    //                         floatingLabelText={`Widget ${locale} name`}
    //                     />
    //                 );
    //             })}
    //         </div>
    //     );
    // };

    // renderWidgetTags = widget => {
    //     if (_.isEmpty(widget.tags)) {
    //         return (
    //             <strong style={{ display: 'block', margin: '14px auto 0', opacity: 0.5 }}>
    //                 Widget does not have any tags yet.
    //             </strong>
    //         );
    //     }
    //     return widget.tags.map((tag, i) => {
    //         return (
    //             <Chip style={{ margin: '4px' }} key={i} onRequestDelete={() => this.handleTagDelete(widget.id, tag)}>
    //                 {tag}
    //             </Chip>
    //         );
    //     });
    // };

    renderRlzWidget = widget => {
        const user = auth.getUser();
        // const snapshotUrl = `${config.widgets.url}/widget/${user.client}/${user.username}/default/${
        //     widget.id
        // }/image?a=69`;

        return (
            <div>
                <rlz-widget
                    style={{ zoom: 0.5 }}
                    data-name={widget.id}
                    data-username={user.username}
                    data-client={user.client}
                    {...RCore.obj2InjectorParams(widget.spec.demo[0].props)}
                    data-template={user.defaultTemplateId}
                />
            </div>
        );
    };

    renderedCenteredMessage = message => {
        return (
            <div
                style={{
                    height: 'calc(100% - 284px)',
                    width: '100%',
                    display: 'flex',
                }}
            >
                <div style={{ margin: 'auto', textAlign: 'center' }}>
                    <div
                        style={{
                            fontWeight: 700,
                            fontSize: '20px',
                            marginBottom: '15px',
                        }}
                    >
                        {message}
                    </div>
                </div>
            </div>
        );
    };

    renderSaveButton = widgetId => {
        let label = 'Saved';
        if (this.state.saving) label = 'Saving...';
        else if (this.state.changed) label = 'Save';

        return (
            <RaisedButton
                primary
                disabled={this.state.saving || !this.state.changed}
                label={label}
                onTouchTap={() => this.handleSave(widgetId)}
            />
        );
    };

    render() {
        const { widgets, dataLoaded, widgetsFiltering } = this.state;
        const { widgetId } = this.props.params;

        if (!dataLoaded) {
            return (
                <Loader>
                    <CircularProgress size={80} thickness={5} />
                </Loader>
            );
        }

        const widget = this.state.widget;
        const { name: widgetName } = widget;

        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <h2 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ opacity: 0.5 }}>{widgetName || 'Widgets dashboard'}</span>
                            {this.renderSaveButton(widgetId)}
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-9 wdp-container">
                        {widget.id && this.renderWidgetI18(widget)}
                        {widget.id && this.renderWidgetI18Controls()}
                        <div className="row">
                            {widget.id && (
                                <div style={{ marginTop: 20 }} className="col-md-12">
                                    {this.renderRlzWidget(widget)}
                                </div>
                            )}
                            {/*{widget.id && (*/}
                            {/*<div className={'col-sm-12'}>*/}
                            {/*{*/}
                            {/*<WidgetDashboardWrapper>*/}
                            {/*{this.renderForm(widget)}*/}
                            {/*<ControlWrapper>{this.renderSaveButton(widgetId)}</ControlWrapper>*/}
                            {/*</WidgetDashboardWrapper>*/}
                            {/*}*/}
                            {/*</div>*/}
                            {/*)}*/}
                            {!widget.id &&
                                this.renderedCenteredMessage('Choose widget from right panel to start editing')}
                        </div>
                        <Snackbar
                            open={this.state.showSavedNotification}
                            onRequestClose={() => this.setState({ showSavedNotification: false })}
                            autoHideDuration={3000}
                            message="Successfully saved"
                        />
                        <Snackbar
                            open={this.state.showErrorNotification}
                            onRequestClose={() =>
                                this.setState({
                                    showErrorNotification: false,
                                    errorNotificationMessage: '',
                                })
                            }
                            autoHideDuration={3000}
                            bodyStyle={{ backgroundColor: 'rgba(198,40,40,0.8)' }}
                            message={this.state.errorNotificationMessage || 'Error occured'}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Paper>
                            <div style={{ padding: '1px 16px 10px' }}>
                                <h4 style={{ marginBottom: 0 }}>Choose widget to edit</h4>
                                <TextField
                                    fullWidth
                                    hintText="Filter by widget name"
                                    value={this.state.widgetsFiltering}
                                    onChange={(e, newValue) => this.setState({ widgetsFiltering: newValue })}
                                />
                                <Toggle
                                    checked={this.state.social}
                                    label="Social widgets only"
                                    onToggle={(e, val) => {
                                        this.setState({ social: val });
                                    }}
                                />
                            </div>

                            <div
                                style={{
                                    overflowY: 'scroll',
                                    overflowX: 'hidden',
                                    height: 'calc(100% - 284px)',
                                    marginBottom: '40px',
                                }}
                            >
                                <div style={{ paddingBottom: '400px' }}>
                                    {_.sortBy(widgets, w => w.id)
                                        .filter(w => (this.state.social ? w.spec.social : true))
                                        .filter(w =>
                                            widgetsFiltering
                                                ? (w.name || w.id)
                                                      .toLowerCase()
                                                      .indexOf(widgetsFiltering.toLowerCase()) > -1
                                                : true,
                                        )
                                        .map(w => {
                                            return (
                                                <MenuItem
                                                    key={w.id}
                                                    style={{
                                                        padding: 0,
                                                        width: '100%',
                                                        height: '20px',
                                                        lineHeight: '20px',
                                                        minHeight: '20px',
                                                        fontSize: '14px',
                                                    }}
                                                >
                                                    <Link
                                                        style={{
                                                            display: 'block',
                                                            padding: '0 24px',
                                                            margin: '0 -24px',
                                                            opacity: w.id === widgetId ? 1 : 0.4,
                                                            textDecoration: w.id === widgetId ? 'underline' : 'none',
                                                        }}
                                                        to={`/admin/widgets-dashboard/${w.id}`}
                                                    >
                                                        {w.name || `[ID]: ${w.id}`}
                                                    </Link>
                                                </MenuItem>
                                            );
                                        })}
                                </div>
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        );
    }
}

WidgetDashboard.propTypes = {
    params: PropTypes.shape({
        widgetId: PropTypes.string,
    }),
    loadCommonDictionary: PropTypes.func.isRequired,
    saveWidgetTranslations: PropTypes.func.isRequired,
};

export default connect(
    null,
    { loadCommonDictionary, saveWidgetTranslations },
)(WidgetDashboard);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetDashboard.js
 **/